import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const GDPRPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  // Robust fallback for translation arrays
  const rightsList = t.gdpr.rights.list;
  const purposesList = t.gdpr.dataProcessing.purposes;
  const safeRightsList = Array.isArray(rightsList) ? rightsList : [];
  const safePurposesList = Array.isArray(purposesList) ? purposesList : [];

  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-8">{t.gdpr.title}</h1>

        {/* Introduction */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">{t.gdpr.introduction.title}</h2>
          <p className="text-gray-700">{t.gdpr.introduction.content}</p>
        </section>

        {/* Rights */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">{t.gdpr.rights.title}</h2>
          <ul className="list-disc pl-6 space-y-4">
            {safeRightsList.map((right, index) => (
              <li key={index}>
                <div className="font-semibold">{right.title}</div>
                <div className="text-gray-700">{right.description}</div>
              </li>
            ))}
          </ul>
        </section>

        {/* Data Processing */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">{t.gdpr.dataProcessing.title}</h2>
          <p className="text-gray-700">{t.gdpr.dataProcessing.content}</p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            {safePurposesList.map((purpose, index) => (
              <li key={index} className="text-gray-700">{purpose}</li>
            ))}
          </ul>
        </section>

        {/* Data Retention */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">{t.gdpr.dataRetention.title}</h2>
          <p className="text-gray-700">{t.gdpr.dataRetention.content}</p>
        </section>

        {/* Contact */}
        <section>
          <h2 className="text-xl font-semibold mb-2">{t.gdpr.contact.title}</h2>
          <p className="text-gray-700">{t.gdpr.contact.content}</p>
          <p className="text-gray-700 font-semibold mt-2">{t.gdpr.contact.email}</p>
        </section>
      </div>
    </div>
  );
};

export default GDPRPage; 